module.exports = __webpack_public_path__ + "img/49800.3c46418c.jpg";